/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import { Button, Link } from '@insticator/insticator-ui'; // iui-material
// styles
import styles from 'material/imageupload/components/controls/controls_styles';
import injectSheet from "react-jss";



/* ========== ~~~~~~~~~~ IMAGE UPLOAD : CONTROLS ~~~~~~~~~~ ========== */
class Controls extends Component {
    render() {
        let { zoom, zoomChange, submit, cancel, onNewSelect, loading, zoomRange } = this.props;

        // add a min range for CEU bg to avoid black bars
        // allow 0.25 zoom for logos
        const minRange = zoomRange && zoomRange.min ? zoomRange.min : 1

        return (
            <div className={`controls ${this.props.classes.controls}`} >
                {!this.props.isGif && <input type="range" min={minRange} max="5" step=".050" value={zoom} className={"slider"} onChange={e=>zoomChange(e.target.value)}  /> }
                <div className={`actions`} >
                    <Button type={'action'} color={'secondary'} name={`submit`} removeLoaderIcon={true} action={submit} text={'Submit'} processing={loading} />
                    <Button type={'action'} color={'attention'} name={`cancel`} action={cancel} text={'Cancel'} />
                    <div className={`newImageButtonContainer`} >
                        <input className={`newImageInput`} type={'file'} onChange={onNewSelect} />
                        <Link name={`newImageButton`} color={'primary'} text={'New Image'} />
                    </div>
                </div>
            </div>
        );
    };
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Controls);
